// CAS běží v každém nasazeném prostředí na vyhrazeném hostu (rpp-*), mimo origin REZA appky.
// Relativní AUTH_BASE_URL ('/auth') je jen pro local dev – tam ho na CAS host routuje proxy.conf.js.
export const AUTH_BASE_URL = '/auth';
export const IVP_AUTH_BASE_URL = 'https://rpp-dev-lb-ais.assecosk.local/auth';
export const INT_AUTH_BASE_URL = 'https://rpp111-int-lb-ais.assecosk.local/auth';
export const TP_AUTH_BASE_URL = 'https://rpp-ais-test.egon.gov.cz/auth';
export const PP_AUTH_BASE_URL = 'https://rpp-ais.egon.gov.cz/auth';

// Výjimka z pravidla výše: na CMS2 doméně (*.cms2.cz) je CAS vystavený na stejné doméně pod /auth,
// takže se volá relativně (same-origin) – viz AuthService._authUrl.
export const CMS2_DOMAIN_SUFFIX = '.cms2.cz';

export const LOGIN_PATH = '/login';
export const VALIDATE_TOKEN_PATH = '/p3/serviceValidate';
export const GET_TOKEN_PATH = '/v1/auth/jwt';
export const LOGOUT_PATH = '/logout';
